// Alarme sonore en boucle — joue tant qu'il y a des réservations payées
// non confirmées côté gérant. Générée via Web Audio API (pas de fichier audio).
// Coordonnée entre onglets via localStorage : un seul onglet joue le son à la fois.
const STORAGE_KEY = 'resipro_alarme';

let alarmeInterval = null;
let audioContext = null;

function jouerBeep() {
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();

  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);

  oscillator.frequency.value = 880;
  oscillator.type = 'sine';

  gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + 0.5);
}

export function demarrerAlarme() {
  if (alarmeInterval) return;
  // Un autre onglet joue déjà l'alarme — ne pas dupliquer le son.
  if (localStorage.getItem(STORAGE_KEY)) return;

  try {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  } catch {
    return;
  }
  localStorage.setItem(STORAGE_KEY, 'active');

  jouerBeep();
  alarmeInterval = setInterval(jouerBeep, 2000);
}

export function arreterAlarme() {
  if (alarmeInterval) {
    clearInterval(alarmeInterval);
    alarmeInterval = null;
  }
  if (audioContext) {
    audioContext.close();
    audioContext = null;
  }
  localStorage.removeItem(STORAGE_KEY);
}

export function alarmeActive() {
  return alarmeInterval !== null;
}

if (typeof window !== 'undefined') {
  // Un autre onglet a arrêté l'alarme (réservation confirmée ailleurs) :
  // si par erreur ce répertoire pensait devoir la démarrer, on annule.
  window.addEventListener('storage', (e) => {
    if (e.key === STORAGE_KEY && !e.newValue && alarmeInterval) {
      arreterAlarme();
    }
  });
  // Libère le verrou localStorage si l'onglet se ferme pendant que l'alarme sonne,
  // pour éviter de bloquer les autres onglets indéfiniment.
  window.addEventListener('beforeunload', () => {
    if (alarmeInterval) localStorage.removeItem(STORAGE_KEY);
  });
}
